:host {
  @apply block;
}

@include base-component();
